import { debounce } from 'ts-debounce';

class ApiActivity {
  private currentApiCalls = 0;

  /**
   * Debounced function for removing the API indicator.
   * Avoids the spinner "flashing" on the page as it is quickly removed and re-added for sequential API calls.
   */
  public removeApiIndicator = debounce(() => {
    if (this.currentApiCalls < 1) {
      const $elm = document.querySelector('#api-event-indicator');
      $elm?.remove();
    }
  }, 50);

  public createSpinnerElement = () => {
    const $parentElm = document.createElement('div');
    $parentElm.setAttribute('id', 'api-event-indicator');
    $parentElm.classList.add('spinner');

    const $line = document.createElement('div');

    $parentElm.append($line);
    $parentElm.append($line);
    $parentElm.append($line);

    document.body.append($parentElm);
  }

  public startCall() {
    this.currentApiCalls = this.currentApiCalls ? this.currentApiCalls + 1 : 1;

    if (!document.querySelector('#api-event-indicator')) {
      this.createSpinnerElement();
    }
  }

  public endCall() {
    this.currentApiCalls -= 1;

    if (this.currentApiCalls < 1) {
      this.removeApiIndicator();
    }
  }
}

export default ApiActivity;
